import { render, staticRenderFns } from "./QRButton.vue?vue&type=template&id=1f30401a&"
import script from "./QRButton.vue?vue&type=script&lang=js&"
export * from "./QRButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports